import entrepreneurs from "./entrepreneurs";
import supporters from "./supporters";

export default [entrepreneurs, supporters];
